import { assertPartialSchema, createAction, useSelector, v } from "../../../lib";

export enum PendingRequestActionType {
  PENDING_REQUEST_SET = "PENDING_REQUEST_SET",
  PENDING_REQUEST_DELETE = "PENDING_REQUEST_DELETE",
}

export const doPENDING_REQUEST_SET = createAction(PendingRequestActionType.PENDING_REQUEST_SET);
export const doPENDING_REQUEST_DELETE = createAction(
  PendingRequestActionType.PENDING_REQUEST_DELETE,
);

export interface RequestPayload {
  [key: string]: any;
}

export interface RequestPayloadWithId extends RequestPayload {
  requestId: string;
}

export interface PendingRequest {
  [requestId: string]: RequestPayload;
}

export interface PendingRequestState {
  [reqeustType: string]: PendingRequest;
}

interface RootState {
  pendingRequest: PendingRequestState;
}

export const useSelectPendingRequest = (requestType: string) => {
  return useSelector((state: RootState) => state.pendingRequest[requestType]);
};

export const pendingRequestActionCreators = {
  doPENDING_REQUEST_SET,
  doPENDING_REQUEST_DELETE,
};

export const defaultPendingRequestState: PendingRequestState = {};

type Action =
  | {
      type: PendingRequestActionType.PENDING_REQUEST_SET;
      payload: {
        requestType: string;
        payload: RequestPayloadWithId;
      };
    }
  | {
      type: PendingRequestActionType.PENDING_REQUEST_DELETE;
      payload: {
        requestType: string;
        requestId: string;
      };
    };

export const pendingRequestReducer = (
  state: PendingRequestState = defaultPendingRequestState,
  { type, payload }: Action,
) => {
  switch (type) {
    case PendingRequestActionType.PENDING_REQUEST_SET: {
      assertPartialSchema({
        payload,
        schema: v.object({
          requestType: v.string().required(),
          payload: v.object().required(),
        }),
      });
      const newState = { ...state };
      const { requestType } = payload;
      const { requestId, ...requestPayload } = payload.payload;
      if (!requestId) return newState;
      const existingForType = newState[requestType];
      newState[requestType] = existingForType
        ? { ...existingForType, [requestId]: requestPayload }
        : { [requestId]: requestPayload };
      return newState;
    }

    case PendingRequestActionType.PENDING_REQUEST_DELETE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          requestType: v.string().required(),
          requestId: v.string().required(),
        }),
      });

      const existingForType = state[payload.requestType];
      if (!existingForType || !existingForType[payload.requestId]) {
        return state;
      }

      const newState = { ...state };
      if (Object.keys(existingForType).length === 1) {
        delete newState[payload.requestType];
      } else {
        newState[payload.requestType] = { ...existingForType };
        delete newState[payload.requestType][payload.requestId];
      }

      return newState;
    }

    default:
      return state;
  }
};
